import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const FilterActionWrapper = styled.button.attrs({ type: 'button' })`
    &&& {
        ${styledReset.button};
        // max-width: 100%;
    }
`;
